module.exports = __webpack_public_path__ + "img/md1.49c11e35.png";